import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';
import './UserCreate.css';

const UnitCreate = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { company } = location.state || {};

    const [unitName, setUnitName] = useState('');
    const [unitNickname, setUnitNickname] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });

        if (!unitName.trim()) {
            setMessage({ type: 'error', text: 'Preencha o nome da unidade.' });
            return;
        }

        if (!company?.id) {
            setMessage({ type: 'error', text: 'Empresa não identificada. Volte e tente novamente.' });
            return;
        }

        try {
            setSubmitting(true);
            const result = await apiService.createUnit({
                company_id: company.id,
                name: unitName.trim(),
                nickname: unitNickname.trim() || null,
            });

            if (result.success) {
                setMessage({ type: 'success', text: `Unidade "${unitName.trim()}" cadastrada com sucesso!` });
                setUnitName('');
                setUnitNickname('');
            } else {
                setMessage({ type: 'error', text: result.message || 'Erro ao cadastrar unidade.' });
            }
        } catch (err) {
            setMessage({ type: 'error', text: 'Erro ao cadastrar unidade. Tente novamente.' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="user-create">
            <div className="user-create-header">
                <button className="btn-back" onClick={() => navigate('/users')}>
                    &#8592; Voltar
                </button>
                <h1>Cadastrar Unidade</h1>
            </div>

            {message.text && (
                <div className={`alert alert-${message.type}`}>
                    {message.text}
                </div>
            )}

            <form className="user-create-form" onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="company">Empresa</label>
                        <input
                            id="company"
                            type="text"
                            value={company?.name || ''}
                            disabled
                            className="form-input"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="unitName">Nome da Unidade</label>
                        <input
                            id="unitName"
                            type="text"
                            value={unitName}
                            onChange={(e) => setUnitName(e.target.value)}
                            className="form-input"
                            placeholder="ex: Brasília"
                            autoFocus
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="unitNickname">Apelido (opcional)</label>
                        <input
                            id="unitNickname"
                            type="text"
                            value={unitNickname}
                            onChange={(e) => setUnitNickname(e.target.value)}
                            className="form-input"
                            placeholder="ex: BSB"
                        />
                    </div>
                </div>

                <div className="form-actions">
                    <button
                        type="button"
                        className="btn btn-cancel"
                        onClick={() => navigate('/users')}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="btn btn-submit"
                        disabled={submitting}
                    >
                        {submitting ? 'Cadastrando...' : 'Cadastrar Unidade'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default UnitCreate;
